import { useEffect } from 'react';
export function useGlobalKeyDown(onKeyDown) {
  return useEffect(function () {
    addEventListener('keydown', onKeyDown);
    return function () {
      return removeEventListener('keydown', onKeyDown);
    };
  }, [onKeyDown]);
}